<div class="container">

  @if (galleryThumbs$ | async; as thumbs) {
    <div class="gallery">
      @for (thumb of thumbs; track thumb) {
        @if (thumb | async; as data) {
          <span class="details-item" (click)="goToLink(data.container.superZoom?.url)">
            <cx-media
              [container]="data.container"
              tabindex="0"
              format="product"
              >
            </cx-media>
            <div class="media-text">{{data.container.superZoom?.altText }}</div>
          </span>
        }
      }
    </div>
  }

  @if (galleryThumbs$ | async; as thumbs) {
    <hr>
    }

    @if (detailsThumbs$ | async; as thumbs) {
      <div class="details">
        @for (thumb of thumbs; track thumb) {
          @if (thumb | async; as data) {
            <span class="details-item" (click)="goToLink(data.container.superZoom?.url)">
              <cx-media
                [container]="data.container"
                tabindex="0"
                format="product"
                >
              </cx-media>
              <div class="media-text">{{data.container.superZoom?.altText }}</div>
            </span>
          }
        }
      </div>
    }

    @if (detailsThumbs$ | async; as thumbs) {
      <hr>
      }

      @if (product$ | async; as product) {
        @if (product.dataSheets && product.dataSheets.length > 0) {
          <div class="data-sheets">
            @for (dataSheet of product.dataSheets; track dataSheet) {
              <span class="data-sheets-item" (click)="goToLink(resolveAbsoluteUrl(dataSheet.url))">
                @if (dataSheet.mimeType === 'application/pdf') {
                  <img src="assets/images/mimetypes/icon-pdf.png">
                }
                <div class="alttext"><div class="alttextP">{{dataSheet.altText}}</div></div>
              </span>
            }
          </div>
        }
        @if (product.dataSheets && product.dataSheets.length > 0) {
          <hr>
          }
          @if (product.dealerInformation && product.dealerInformation.length > 0) {
            <div class="dealer-information">
              @for (dealerInformation of product.dealerInformation; track dealerInformation) {
                <span class="dealer-information-item" (click)="goToLink(resolveAbsoluteUrl(dealerInformation.url))">
                  @if (dealerInformation.mimeType === 'application/pdf') {
                    <img src="assets/images/mimetypes/icon-pdf.png">
                  }
                  <div>{{dealerInformation.altText}}</div>
                </span>
              }
            </div>
          }
        }
      </div>
